/**
 * Url.js
 *
 * A collection of url-related helpers.
 */
export default class Url {
    static get scheme() {
        return window.location.protocol;
    }

    static get host() {
        return window.location.host;
    }

    static get path() {
        return window.location.pathname;
    }

    static get base() {
        return this.scheme + "//" + this.host;
    }

    static get current() {
        return this.base + this.path;
    }

    static toQueryString(obj) {
        var query = [];
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (_.isArray(obj[key])) {
                    obj[key].forEach(value => {
                        query.push(
                            encodeURIComponent(key) + "[]=" + encodeURIComponent(value)
                        );
                    })
                } else {
                    query.push(
                        encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
                    );
                }
            }
        }
        return query.join("&");
    }
}
